import React from 'react'

import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    name: string
 *    className?: string
 *    disabled?: boolean
 *    onChange?: any
 *    value?: string
 * }} props
 * @returns {React.Component}
 */
const ZariFormTextArea = ({ className, ...props }) => {
  return (
    <Form.Control
      {...props}
      className={clsx('zr-form__textarea', className)}
      size='sm'
      as='textarea'
    />
  )
}

ZariFormTextArea.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.any
}

export default ZariFormTextArea
